import { Box, Step, StepLabel, Stepper } from '@mui/material';

import { ButtonsBlock } from './ButtonsBlock';
import * as styles from './FormStepper.styles';
import type { FormStepperProps } from './types';

const FormStepper = ({
  activeStep,
  stepsTitles,
  containerSx,
  header,
  children,
  setActiveStep,
  handleSubmit,
  currentSchema,
}: FormStepperProps) => {
  return (
    <Box sx={containerSx} data-cy="form-stepper">
      {header}
      <Box sx={styles.stepperBlock} data-cy="stepper">
        <Stepper activeStep={activeStep}>
          {stepsTitles.map((label) => (
            <Step sx={styles.step} key={label} data-cy="stepp">
              <StepLabel data-cy="stepLabel">{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
      {children}
      <ButtonsBlock
        activeStep={activeStep}
        stepsCount={stepsTitles.length}
        setActiveStep={setActiveStep}
        handleSubmit={handleSubmit}
        currentSchema={currentSchema}
      />
    </Box>
  );
};

export default FormStepper;
